// extracted by mini-css-extract-plugin
export default {"tab":"PageTab_tab__pA8bk","totalCountText":"PageTab_totalCountText__Licdz","mobile":"PageTab_mobile__CjP3N","active":"PageTab_active__zlGUh","disabled":"PageTab_disabled__2AbRe"};